import { reduxForm } from 'redux-form';
import ListItemForm from 'pap/components/common/input_fields/item_form';

export default reduxForm({form: 'list_item'})(ListItemForm);
